import { fontList } from '../../core/font-list';
import {colorListPairs, colorMap,colorListCharts} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '900 x 600',
        'value': [900, 600],
        'label': '900 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 900,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 50,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 80,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 80,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColor': {
      'default': '#8AAFC9',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconColor': {
      'default': '#FFFFFF',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 1,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': 580,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': 150,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundX': {
      'default': 510,
      'label': 'logoBackgroundX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundY': {
      'default': 85,
      'label': 'logoBackgroundY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundRadius': {
      'default': 60,
      'label': 'logoBackgroundRadius',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundColor': {
      'default': '#FFFFFF',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBorderColor': {
      'default': '#069',
      'label': 'logoBorderColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBackgroundRadiusWidth': {
      'default': 3,
      'label': 'logoBackgroundRadiusWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 60,
      'label': 'logoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 0,
      'label': 'logoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 0,
      'label': 'logoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#222222',
      'label': 'logoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'textWidth': {
      'default': 380,
      'label': 'textWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'textX': {
      'default': 50,
      'label': 'textX',
      'type': 'number',
      'control': 'standard-number',
    },
    'textY': {
      'default': 190,
      'label': 'textY',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1X': {
      'default': 50,
      'label': 'titleTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1Y': {
      'default': 80,
      'label': 'titleTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1': {
      'default': 'Bevölkerung in Hessen wächst\nim 1. Halbjahr 2017 auf\nknapp 6,23 Millionen',
      'label': 'titleTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleTextSlide1FontSize': {
      'default': 38,
      'label': 'titleTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1LineHeight': {
      'default': 1.4,
      'label': 'titleTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1FontColor': {
      'default': '#004B95',
      'label': 'titleTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1X': {
      'default': 50,
      'label': 'textSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1Y': {
      'default': 430,
      'label': 'textSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1': {
      'default': 'Dies ist eine Zunahme von 0,3%',
      'label': 'textSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textSlide1FontSize': {
      'default': 32,
      'label': 'textSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1LineHeight': {
      'default': 1.4,
      'label': 'textSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'textSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1FontWeight': {
      'default': 'bold',
      'label': 'textSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': 'Bevölkerungsentwicklung in Hessen',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 20,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 80,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 32,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': '',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line2': {
      'default': '',
      'label': 'subtitleTextSlide2Line2',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2X': {
      'default': 20,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 95,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 3,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 6,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 3,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': 'in Millionen.',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'Verdana',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 24,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Verdana',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '1950',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2016',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#e6013aff', '#0081d2ff' , '#ccccccff'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'legend': {
      'default': false,
      'label': 'Show legend',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    // 'legendRows': {
    //   'default': 1,
    //   'label': 'Aantal rijen in de legend',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    'legendFontFamily': {
      'default': 'Verdana',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'legendItemWidth' : {
      'default': 30,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': 80,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 20,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText': {
      'default': 5,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Bevolking'], [4.343720], [4.392584], [4.431317], [4.477998], [4.520818], [4.577198], [4.541837], [4.599724], [4.651483], [4.702808], [4.783352], [4.861250], [4.936942], [5.004893], [5.086611], [5.170449], [5.239723], [5.262729], [5.333200], [5.422567], [5.424529], [5.489728], [5.532965], [5.583822], [5.576081], [5.549823], [5.538432], [5.540585], [5.553508], [5.576085], [5.601031], [5.611851], [5.599799], [5.564964], [5.535185], [5.529413], [5.543657], [5.524637], [5.568892], [5.660619], [5.763310], [5.837330], [5.922639], [5.967305], [5.980693], [6.009913], [6.027284], [6.031705], [6.035137], [6.051966], [6.068129], [6.077826], [6.091618], [6.089428], [6.097765], [6.092354], [6.075359], [6.072555], [6.064953], [6.061951], [6.067021], [5.993771], [6.016481], [6.045425], [6.093888], [6.176172], [6.213088]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColor', 'iconColor', 'iconOpacity', 'iconX', 'iconY', 'titleTextSlide1', 'titleTextSlide1Y', 'textSlide1', 'textSlide1Y'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-hessen-triptych-line-hor-steps/social.params.ts